export const CHART_SELECTOR_HEIGHT = 70;
